<template>
  <h3 class="-title">
    {{title[0]}}
    <span class="sub" v-if="title.length > 1">{{title[1]}}</span>
  </h3>
</template>

<script>
export default {
  name: 'title-bar',
  props: {
    title: Array,
    required: true
  }
}
</script>

<style scoped lang="less">
  .-title {
    font-size: 20px;
    color: #333333;
    padding-left: 8px;
    padding-top: 2px;
    text-align: left;
    font-weight: 400;
    margin: 0 0 30px 0;
    border-left: 5px solid #1362FF;
    .sub {
      font-size: 14px;
      color: #97A8BE;
      margin-left: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/di-ding/common/title-bar.vue